import { asClass, asValue, createContainer } from 'awilix';
import { 
//==========================================
// Adapters
//==========================================
AccountManagementRestAdapter, AlertsEventsDispatcher, ContributionsRestAdapter, ContributionsVEFRestAdapter, DemandesApprenantsRestAdapter, DemandesComplementPiecesRestAdapter, DemandesFinancementRestAdapter, I18nAdapter, JustificationsRestAdapter, LocalStorageAdapter, MasterDataRestAdapter, MenuRestAdapter, PublicSettingsRestAdapter, RestHttpAdapter, SollicitationsRestAdapter, TeleserviceRestAdapter, TiersAccountRestAdapter, TiersRestAdapter, DocumentsRestAdapter, } from '@mgdis/eu-adapters';
import { AccountManagementService, 
//==========================================
// Types
//==========================================
AlertTypes, ContributionsInformationService, ContributionsService, DateFormatterService, ContributionsVEFActions, ContributionsVEFFormatter, ContributionsVEFService, DemandesApprenantsActions, DemandesApprenantsFormatter, DemandesApprenantsService, DemandesFinancementActions, DemandesFinancementFormatter, DemandesFinancementService, DossiersFinancementService, EntreeFormationActions, 
//==========================================
// Services
//==========================================
I18nService, DemandesComplementPiecesService, JustificationsService, LinkTypeService, MenuService, PublicSettingsService, SessionService, SollicitationsFormatter, SollicitationsService, SollicitationsTypes, SollicitationsActions, StoreService, TeleserviceService, TiersAccountService, TiersPersonnaliteJuridique, TiersService, TiersTypeFamille, MasterDataService, EventsService, DocumentsService, SanitizerService, } from '@mgdis/eu-domain';
// eslint-disable-next-line @typescript-eslint/no-namespace
var AppLoader;
(function (AppLoader) {
    // Create the container and set the injectionMode to PROXY (which is also the default).
    const container = createContainer();
    // Get tenant id from the location url
    const locationMatchs = window.location.href.match(/#\/(.*?)(\/|$)/);
    const tenantId = locationMatchs?.[1] ?? '';
    const singleton = (entity) => asClass(entity).singleton();
    container.register({
        tenantId: asValue(tenantId),
        // register default value, we can overwrite it later
        timeZone: asValue('Europe/Paris'),
        // http driver
        restHttpAdapter: singleton(RestHttpAdapter),
        // Alerts Dispatcher
        alertsDispatcher: singleton(AlertsEventsDispatcher),
        // Store
        storeService: singleton(StoreService),
        // I18n
        i18nAdapter: singleton(I18nAdapter),
        i18nService: singleton(I18nService),
        // Account Management
        accountManagementAdapter: singleton(AccountManagementRestAdapter),
        accountManagementService: singleton(AccountManagementService),
        // Storage (npm store2 LocalStorage)
        storageAdapter: singleton(LocalStorageAdapter),
        sessionService: singleton(SessionService),
        // Menu
        menuAdapter: singleton(MenuRestAdapter),
        menuService: singleton(MenuService),
        // Tiers
        tiersAdapter: singleton(TiersRestAdapter),
        tiersService: singleton(TiersService),
        // Tiers account
        tiersAccountAdapter: singleton(TiersAccountRestAdapter),
        tiersAccountService: singleton(TiersAccountService),
        // Demandes financement
        demandesFinancementAdapter: singleton(DemandesFinancementRestAdapter),
        demandesFinancementFormatter: singleton(DemandesFinancementFormatter),
        demandesFinancementService: singleton(DemandesFinancementService),
        // Demandes apprenants
        demandesApprenantsAdapter: singleton(DemandesApprenantsRestAdapter),
        demandesApprenantsFormatter: singleton(DemandesApprenantsFormatter),
        demandesApprenantsService: singleton(DemandesApprenantsService),
        // Demandes complement pieces
        demandesComplementPiecesAdapter: singleton(DemandesComplementPiecesRestAdapter),
        demandesComplementPiecesService: singleton(DemandesComplementPiecesService),
        // Sollicitations
        sollicitationsAdapter: singleton(SollicitationsRestAdapter),
        sollicitationsFormatter: singleton(SollicitationsFormatter),
        sollicitationsService: singleton(SollicitationsService),
        // Justifications
        justificationsAdapter: singleton(JustificationsRestAdapter),
        justificationsService: singleton(JustificationsService),
        // Contributions
        contributionsAdapter: singleton(ContributionsRestAdapter),
        contributionsService: singleton(ContributionsService),
        contributionsInformationService: singleton(ContributionsInformationService),
        // Public settings
        publicSettingsAdapter: singleton(PublicSettingsRestAdapter),
        publicSettingsService: singleton(PublicSettingsService),
        // Dossiers Financement
        dossiersFinancementService: singleton(DossiersFinancementService),
        // Date formatter
        dateFormatterService: singleton(DateFormatterService),
        // Contributions VEF
        contributionsVEFAdapter: singleton(ContributionsVEFRestAdapter),
        contributionsVEFService: singleton(ContributionsVEFService),
        contributionsVEFFormatter: singleton(ContributionsVEFFormatter),
        // Teleservice
        teleserviceAdapter: singleton(TeleserviceRestAdapter),
        teleserviceService: singleton(TeleserviceService),
        // Master Data
        masterDataAdapter: singleton(MasterDataRestAdapter),
        masterDataService: singleton(MasterDataService),
        // Link type
        linkTypeService: singleton(LinkTypeService),
        // Events
        eventsService: singleton(EventsService),
        // Documents
        documentsAdapter: singleton(DocumentsRestAdapter),
        documentsService: singleton(DocumentsService),
        // Sanitizer
        sanitizerService: singleton(SanitizerService),
    });
    /**
     * Return i18n service
     * @returns i18n service
     */
    function getI18nServiceInstance() {
        return container.resolve('i18nService');
    }
    AppLoader.getI18nServiceInstance = getI18nServiceInstance;
    /**
     * Return store serviceimport camelCase from 'camelcase';
  
     * @returns store service
     */
    function getStoreServiceInstance() {
        return container.resolve('storeService');
    }
    AppLoader.getStoreServiceInstance = getStoreServiceInstance;
    /**
     * Return Session Service instance
     * @returns JWT service domain
     */
    function getSessionServiceInstance() {
        return container.resolve('sessionService');
    }
    AppLoader.getSessionServiceInstance = getSessionServiceInstance;
    /**
     * Return demande tiers service instance
     * @returns tiers service domain
     */
    function getTiersServiceInstance() {
        return container.resolve('tiersService');
    }
    AppLoader.getTiersServiceInstance = getTiersServiceInstance;
    /**
     * Return demande tiers service instance
     */
    function getTiersAccountServiceInstance() {
        return container.resolve('tiersAccountService');
    }
    AppLoader.getTiersAccountServiceInstance = getTiersAccountServiceInstance;
    /**
     * Return Sollicitations instance
     * @returns sollicitations domain
     */
    function getSollicitationsInstance() {
        return container.resolve('sollicitationsService');
    }
    AppLoader.getSollicitationsInstance = getSollicitationsInstance;
    /**
     * Return Sollicitations formatter instance
     * @returns sollicitations formatter
     */
    function getSollicitationsFormatterInstance() {
        return container.resolve('sollicitationsFormatter');
    }
    AppLoader.getSollicitationsFormatterInstance = getSollicitationsFormatterInstance;
    /**
     * Return Menu instance
     * @returns menu domain
     */
    function getMenuInstance() {
        return container.resolve('menuService');
    }
    AppLoader.getMenuInstance = getMenuInstance;
    /**
     * Return Demandes Financement service instance
     * @returns demandes financement domain
     */
    function getDemandesFinancementInstance() {
        return container.resolve('demandesFinancementService');
    }
    AppLoader.getDemandesFinancementInstance = getDemandesFinancementInstance;
    /**
     * Return Demandes Financement formatter instance
     * @returns demandes financement formatter
     */
    function getDemandesFinancementFormatterInstance() {
        return container.resolve('demandesFinancementFormatter');
    }
    AppLoader.getDemandesFinancementFormatterInstance = getDemandesFinancementFormatterInstance;
    /**
     * Return Demandes Apprenants instance
     * @returns demandes apprenants domain
     */
    function getDemandesApprenantsInstance() {
        return container.resolve('demandesApprenantsService');
    }
    AppLoader.getDemandesApprenantsInstance = getDemandesApprenantsInstance;
    /**
     * Return Demandes Apprenants Formatter instance
     * @returns demandes apprenants formatter domain
     */
    function getDemandesApprenantsFormatterInstance() {
        return container.resolve('demandesApprenantsFormatter');
    }
    AppLoader.getDemandesApprenantsFormatterInstance = getDemandesApprenantsFormatterInstance;
    /**
     * Return DemandesComplementPiecesService instance
     * @returns DemandesComplementPiecesService instance
     */
    function getDemandesComplementPiecesServiceInstance() {
        return container.resolve('demandesComplementPiecesService');
    }
    AppLoader.getDemandesComplementPiecesServiceInstance = getDemandesComplementPiecesServiceInstance;
    /**
     * Return Contributions instance
     * @returns sollicitations domain
     */
    function getContributionsInstance() {
        return container.resolve('contributionsService');
    }
    AppLoader.getContributionsInstance = getContributionsInstance;
    /**
     * Return Justifications instance
     * @returns justifications domain
     */
    function getJustificationsInstance() {
        return container.resolve('justificationsService');
    }
    AppLoader.getJustificationsInstance = getJustificationsInstance;
    /**
     * Return Account Management instance
     * @returns account management domain
     */
    function getAccountManagementInstance() {
        return container.resolve('accountManagementService');
    }
    AppLoader.getAccountManagementInstance = getAccountManagementInstance;
    /**
     * Return Alerts instance
     * @returns alerts domain
     */
    function getAlertsDispatcherInstance() {
        return container.resolve('alertsDispatcher');
    }
    AppLoader.getAlertsDispatcherInstance = getAlertsDispatcherInstance;
    /**
     * Return PublicSettingsService instance
     */
    function getPublicSettingsInstance() {
        return container.resolve('publicSettingsService');
    }
    AppLoader.getPublicSettingsInstance = getPublicSettingsInstance;
    /**
     * Return dossier financement instance
     */
    function getDossiersFinancementInstance() {
        return container.resolve('dossiersFinancementService');
    }
    AppLoader.getDossiersFinancementInstance = getDossiersFinancementInstance;
    function getDateFormatterInstance() {
        return container.resolve('dateFormatterService');
    }
    AppLoader.getDateFormatterInstance = getDateFormatterInstance;
    /**
     * Return dossier financement instance
     */
    function getContributionsVEFInstance() {
        return container.resolve('contributionsVEFService');
    }
    AppLoader.getContributionsVEFInstance = getContributionsVEFInstance;
    /**
     * Return dossier financement instance
     */
    function getContributionsVEFFormatterInstance() {
        return container.resolve('contributionsVEFFormatter');
    }
    AppLoader.getContributionsVEFFormatterInstance = getContributionsVEFFormatterInstance;
    /**
     * Return TeleserviceService instance
     */
    function getTeleserviceInstance() {
        return container.resolve('teleserviceService');
    }
    AppLoader.getTeleserviceInstance = getTeleserviceInstance;
    /**
     * Return contributionsInformationService instance
     */
    function getContributionsInformationServiceInstance() {
        return container.resolve('contributionsInformationService');
    }
    AppLoader.getContributionsInformationServiceInstance = getContributionsInformationServiceInstance;
    /**
     * Return masterDataService instance
     */
    function getMasterDataServiceInstance() {
        return container.resolve('masterDataService');
    }
    AppLoader.getMasterDataServiceInstance = getMasterDataServiceInstance;
    /**
     * Return masterDataService instance
     */
    function getLinkTypeServiceInstance() {
        return container.resolve('linkTypeService');
    }
    AppLoader.getLinkTypeServiceInstance = getLinkTypeServiceInstance;
    /**
     * Return eventsService instance
     */
    function getEventsServiceInstance() {
        return container.resolve('eventsService');
    }
    AppLoader.getEventsServiceInstance = getEventsServiceInstance;
    /**
     * Return eventsService instance
     */
    function getDocumentsServiceInstance() {
        return container.resolve('documentsService');
    }
    AppLoader.getDocumentsServiceInstance = getDocumentsServiceInstance;
    /**
     * Return types enum
     */
    function getTypes() {
        return {
            SollicitationsTypes,
            SollicitationsActions,
            DemandesFinancementActions,
            DemandesApprenantsActions,
            ContributionsVEFActions,
            EntreeFormationActions,
            TiersPersonnaliteJuridique,
            TiersTypeFamille,
            AlertTypes,
        };
    }
    AppLoader.getTypes = getTypes;
    /**
     * Register a new value for tenantId
     * @param tenantId - tenant identifier
     */
    function registerTenantId(tenantId) {
        container.register({
            tenantId: asValue(tenantId),
        });
    }
    AppLoader.registerTenantId = registerTenantId;
    /**
     * Register a new timeZone
     * @param timeZone - timezone value (ex: Europe/Paris)
     */
    function registerTimeZone(timeZone) {
        container.register({
            timeZone: asValue(timeZone),
        });
        // update if needed
        getDateFormatterInstance().setTimeZone(timeZone);
    }
    AppLoader.registerTimeZone = registerTimeZone;
    /**
     * Return registered timeZone
     */
    function getTimeZone() {
        return container.resolve('timeZone');
    }
    AppLoader.getTimeZone = getTimeZone;
    /**
     * Return the sanitizer service
     */
    function getSanitizerService() {
        return container.resolve('sanitizerService');
    }
    AppLoader.getSanitizerService = getSanitizerService;
})(AppLoader || (AppLoader = {}));
export { AppLoader };
//# sourceMappingURL=index.js.map